import { captureApiError, classifyApiError, isSilentApiError } from '@affiliate-cabinet/rest'
import { ResponseErrorCallbackType } from '@affstore-ds/restclient'

export const analyticsClientErrorCallback: ResponseErrorCallbackType = (response) => {
  const { kind, status } = classifyApiError(response)

  if (isSilentApiError(kind)) {
    return
  }

  captureApiError(response, { kind, status })
}
